var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 5.25C12.6642 5.25 13 5.58579 13 6V11.4997H18.5C18.9142 11.4997 19.25 11.8355 19.25 12.2497C19.25 12.6639 18.9142 12.9997 18.5 12.9997H13V18.4994C13 18.9136 12.6642 19.2494 12.25 19.2494C11.8358 19.2494 11.5 18.9136 11.5 18.4994V12.9997H6C5.58579 12.9997 5.25 12.6639 5.25 12.2497C5.25 11.8355 5.58579 11.4997 6 11.4997H11.5V6C11.5 5.58579 11.8358 5.25 12.25 5.25Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewIcon);
export default __webpack_public_path__ + "static/media/add-new_icon.b0dde7613ec1593af69c091315854776.svg";
export { ForwardRef as ReactComponent };